module.exports = __webpack_public_path__ + "img/8-4.4ec3006f.jpg";